<template>
  <section class="seo-home">
    <div class="seo-inner">
      <div class="seo-copy">
        <div class="seo-tag">SEO + ЛІДИ</div>
        <h2>Ремонт телефонів у Харкові для iPhone, Samsung, Xiaomi та інших моделей</h2>
        <p>
          Якщо вам потрібен ремонт телефонів у Харкові, сайт має одразу закривати головні комерційні запити: ремонт iPhone Харків, ремонт Samsung Харків,
          заміна екрану Харків, заміна батареї Харків, ремонт після води Харків, а також російськомовні запити ремонт телефона Харьков і ремонт телефонов Харьков.
          Саме під ці запити ми додали окремі сторінки послуг, блог і внутрішні посилання.
        </p>
        <p>
          MobiFIX PRO працює для людей, яким важливо швидко полагодити телефон і відразу звʼязатися з сервісом. Тому на сайті є форма заявки, помітні контакти,
          Telegram, а також матеріали під довгий хвіст, які допомагають Google краще зрозуміти тематику сайту. Для найгарячішого кластера ми окремо винесли
          сторінку про ремонт телефонов в Харькове, щоб сильніше працювати по локальній комерційній видачі.
        </p>
      </div>

      <div class="seo-links">
        <router-link
          v-for="landing in featuredLandings"
          :key="landing.slug"
          :to="landing.path"
          class="seo-link-card"
        >
          <div class="seo-link-title">{{ landing.h1 }}</div>
          <div class="seo-link-desc">{{ landing.description }}</div>
        </router-link>
      </div>
    </div>

    <div class="seo-block">
      <div class="seo-block-head">
        <h3>Корисні статті для довгого хвоста</h3>
        <router-link to="/blog" class="seo-more-link">Перейти в блог</router-link>
      </div>

      <div class="seo-article-grid">
        <router-link
          v-for="article in featuredArticles"
          :key="article.slug"
          :to="article.path"
          class="seo-article-card"
        >
          <div class="seo-article-title">{{ article.h1 }}</div>
          <p>{{ article.excerpt }}</p>
        </router-link>
      </div>
    </div>

    <div class="seo-block">
      <div class="seo-block-head">
        <h3>Відгуки клієнтів</h3>
      </div>

      <div class="seo-review-grid">
        <article v-for="review in reviews" :key="review.author" class="seo-review-card">
          <div class="seo-review-stars">★★★★★</div>
          <h4>{{ review.author }}</h4>
          <p>{{ review.body }}</p>
        </article>
      </div>
    </div>

    <div class="seo-faq">
      <h3>Часті питання перед зверненням</h3>
      <div class="seo-faq-grid">
        <article v-for="item in faq" :key="item.q" class="seo-faq-card">
          <h4>{{ item.q }}</h4>
          <p>{{ item.a }}</p>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
import { serviceLandings } from '../data/serviceLandings';
import { blogArticles } from '../data/blogArticles';
import { customerReviews } from '../utils/schema';

export default {
  name: 'HomeSeoSection',
  setup() {
    const featuredSlugs = [
      'remont-telefonov-kharkov',
      'terminovyi-remont-telefoniv-kharkiv',
      'iphone-repair',
      'samsung-repair',
      'screen-replacement',
      'water-damage-repair'
    ];
    const faq = [
      {
        q: 'Які телефони ви ремонтуєте?',
        a: 'iPhone, Samsung Galaxy, Xiaomi, Redmi, POCO, Huawei, Honor, OnePlus, Google Pixel та інші моделі.'
      },
      {
        q: 'Скільки чекати на ремонт?',
        a: 'Більшість популярних ремонтів займає від 20 до 60 хвилин. Складні випадки після води або по платі тривають довше.'
      },
      {
        q: 'Чи можна записатися онлайн?',
        a: 'Так. На сайті є кнопка “Замовити ремонт”, а також швидкий звʼязок через дзвінок і Telegram.'
      },
      {
        q: 'Чи робите безкоштовну діагностику?',
        a: 'Так, попередня діагностика безкоштовна. Після неї узгоджуємо точну вартість ремонту.'
      }
    ];

    return {
      faq,
      reviews: customerReviews,
      featuredLandings: featuredSlugs.map((slug) => serviceLandings[slug]).filter(Boolean),
      featuredArticles: blogArticles.slice(0, 4)
    };
  }
};
</script>

<style scoped>
.seo-home {
  background: linear-gradient(180deg, #fff 0%, #f5f7ff 100%);
  padding: 48px 20px 80px;
}

.seo-inner,
.seo-block,
.seo-faq {
  max-width: 1100px;
  margin: 0 auto 28px;
}

.seo-inner {
  display: grid;
  grid-template-columns: 1.08fr 0.92fr;
  gap: 28px;
}

.seo-copy,
.seo-link-card,
.seo-article-card,
.seo-review-card,
.seo-faq-card {
  background: #fff;
  border: 1px solid #dde4ff;
  border-radius: 22px;
  box-shadow: 0 10px 30px rgba(46, 44, 97, 0.06);
}

.seo-copy {
  padding: 28px;
}

.seo-tag {
  display: inline-block;
  margin-bottom: 14px;
  padding: 6px 10px;
  border-radius: 999px;
  background: #edf2ff;
  color: #3146a5;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.seo-copy h2 {
  margin: 0 0 14px;
  font-size: 34px;
  line-height: 1.1;
  color: #1f2357;
}

.seo-copy p {
  margin: 0 0 14px;
  font-size: 16px;
  line-height: 1.75;
  color: #46506d;
}

.seo-links,
.seo-article-grid,
.seo-review-grid,
.seo-faq-grid {
  display: grid;
  gap: 16px;
}

.seo-links {
  gap: 14px;
}

.seo-link-card,
.seo-article-card {
  padding: 18px 20px;
  text-decoration: none;
  transition: transform 0.18s ease, border-color 0.18s ease;
  min-width: 0;
}

.seo-link-card:hover,
.seo-article-card:hover {
  transform: translateY(-2px);
  border-color: #7d8ef1;
}

.seo-link-title,
.seo-article-title {
  margin-bottom: 8px;
  font-size: 18px;
  font-weight: 800;
  color: #202868;
}

.seo-link-desc,
.seo-article-card p {
  font-size: 14px;
  line-height: 1.6;
  color: #5d6480;
  overflow-wrap: anywhere;
}

.seo-block-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}

.seo-block-head h3,
.seo-faq h3 {
  margin: 0;
  font-size: 28px;
  color: #202868;
}

.seo-more-link {
  color: #534ab7;
  font-weight: 700;
  text-decoration: none;
}

.seo-article-grid,
.seo-review-grid,
.seo-faq-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.seo-review-card,
.seo-faq-card {
  padding: 22px;
}

.seo-review-stars {
  margin-bottom: 10px;
  color: #f5a623;
  font-size: 16px;
  letter-spacing: 0.08em;
}

.seo-review-card h4,
.seo-faq-card h4 {
  margin: 0 0 10px;
  font-size: 18px;
  color: #202868;
}

.seo-review-card p,
.seo-faq-card p {
  margin: 0;
  font-size: 15px;
  line-height: 1.7;
  color: #55607a;
  overflow-wrap: anywhere;
}

@media (max-width: 900px) {
  .seo-inner,
  .seo-article-grid,
  .seo-review-grid,
  .seo-faq-grid {
    grid-template-columns: 1fr;
  }

  .seo-copy h2 {
    font-size: 28px;
  }
}

@media (max-width: 640px) {
  .seo-home {
    padding: 36px 16px 72px;
  }

  .seo-copy,
  .seo-review-card,
  .seo-faq-card,
  .seo-link-card,
  .seo-article-card {
    padding: 20px;
  }

  .seo-block-head {
    align-items: flex-start;
    flex-direction: column;
  }
}
</style>
